import React from 'react';
export const FanvoiceTitle = ({ blockName, text }) => {
  const className = `${blockName}__title`;
  return (
     <h2 className={ className }>
        { text }
     </h2>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceTitle.js